import React, { useEffect, useContext, useState } from "react";
import BlurryImage from "../Components/BlurryImage.component";
import { useLocation, Link, useNavigate, useParams } from "react-router-dom";
import { FirebaseContext } from "../admin/context/FirebaseContext";
import { getDoc, doc } from "firebase/firestore";
import { Helmet } from "react-helmet-async";

import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import "../styles/content.style.scss";
import "../styles/product.style.scss";
function ProductInfo() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [product, setProduct] = useState(null);
  const [categorie, setCategorie] = useState(null);

  const { data } = location.state ?? { data: null };
  const { db } = useContext(FirebaseContext);
  const { id } = useParams();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    //console.log(data);
    const getProduct = async () => {
      if (data === null) {
        const productRef = doc(db, "products", id);
        await getDoc(productRef)
          .then((docSnap) => {
            if (docSnap?.exists()) {
              const p = docSnap.data();
              setProduct(p);
              fetchCategorieProduct(p?.categorieProd).then((d) => {
                setCategorie(d.data());
                setLoading(false);
              });
            } else {
              navigate("/ventes", { replace: true });
            }
          })
          .catch((error) => {
            console.log("error ", error);
          });
      } else {
        setLoading(false);
      }
    };
    getProduct();
  }, []);

  const fetchCategorieProduct = async (categorieID) => {
    //console.log(categorieID);
    const categorieRef = doc(db, "categoriesProducts", categorieID);
    const querySnapshot = await getDoc(categorieRef);
    return querySnapshot;
  };

  function handleClickToConctact(e, data) {
    e.preventDefault();
    navigate("/contact", {
      replace: true,
      state: {
        message:
          "Je suis interessé par le produit " +
          data?.nameProd +
          " : " +
          data?.descriptionProd +
          `\n Lien du produit :${window.location.href}`,
      },
    });
  }
  if (loading) {
    return (
      <div className="App top-ctn">
        <div className="ctn-content">
          <Box className="prod-ctn-load">
            <Skeleton
              variant="rectangular"
              className="prod-img-load"
              animation="wave"
              sx={{
                width: "100%",
                borderRadius: "10px",
                margin: "10px 0",
              }}
            />
            <Box className="prod-content-load">
              <Skeleton
                sx={{
                  width: "30%",
                  borderRadius: "10px",
                }}
              />
              <Skeleton
                sx={{
                  width: "80%",
                  borderRadius: "10px",
                }}
              />
              <Skeleton
                sx={{
                  width: "40%",
                  borderRadius: "10px",
                  height: "40px",
                }}
              />
              <Skeleton
                sx={{
                  width: "50%",
                  borderRadius: "10px",
                  height: "100px",
                }}
              />
            </Box>
          </Box>
        </div>
      </div>
    );
  }

  return (
    <>
      <Helmet prioritizeSeoTags>
        <title>Vente: {data?.nameProd ?? product?.nameProd}</title>
        <link
          rel="canonical"
          href={`https://www.generalite-informatique.vercel.app/ventes/produit/${id}`}
        />

        <meta
          property="og:title"
          content={data?.nameProd ?? product?.nameProd}
        />
        <meta
          property="og:description"
          content={data?.descriptionProd ?? product?.descriptionProd}
        />
        <meta
          property="og:image"
          content={data?.imageProd ?? product?.imageProd}
        />
        <meta
          name="twitter:title"
          content={data?.nameProd ?? product?.nameProd}
        />
        <meta
          name="twitter:description"
          content={data?.descriptionProd ?? product?.descriptionProd}
        />
        <meta
          name="twitter:image"
          content={data?.imageProd ?? product?.imageProd}
        />
        <meta property="og:title" content="Contact GI" />
      </Helmet>
      <div className="App top-ctn">
        <div className="ctn-content">
          <div className="ctn-prod-detail">
            <div className="ctn-img-prod">
              <span className="back-btn">
                <Link to="..">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M28.05 36 16 23.95 28.05 11.9l2.15 2.15-9.9 9.9 9.9 9.9Z"></path></svg>
                </Link>
              </span>
              <BlurryImage
                hash={data?.imageHashProd ?? product?.imageHashProd}
                className="cover"
                imageUrl={data?.imageProd ?? product?.imageProd}
              />
            </div>
            <div className="ctn-info">
              <label>Nom</label>
              <h1 className="prod-name">
                {data?.nameProd ?? product?.nameProd}
              </h1>
              <label>Categorie</label>
              <span className="prod-cat">
                {data?.categorie ?? categorie?.name}
              </span>
              <label>Prix</label>
              <h1 className="prod-prix">
                {data?.priceProd ?? product?.priceProd} FCFA
              </h1>
              <label>description</label>
              <p className="prod-desc">
                {data?.descriptionProd ?? product?.descriptionProd}
              </p>
              <button
                className="btn-btn"
                onClick={(e) => handleClickToConctact(e, data ?? product)}
              >
                Nous Contactez
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProductInfo;
